import { useState } from 'react';
import { LuExternalLink } from 'react-icons/lu';

import { BillingLinkEndpoint } from '@core/types/types.endpoint.billing';
import { Button } from '@frontend/components/ui/button';
import { Card, CardContent } from '@frontend/components/ui/card';
import { SettingsUpgradeModal } from '@frontend/Settings/components/SettingsUpgradeModal';
import { useApi } from '@frontend/shared/hooks/shared.hook.useApi';
import { useIsPro } from '@frontend/shared/hooks/shared.hook.useIsPro';
import { useDirectoryTeam } from '@frontend/shared/hooks/useDirectory';

interface SettingsAccountTypeProps {
  isReadOnly?: boolean;
}

export function SettingsAccountType({
  isReadOnly = false,
}: SettingsAccountTypeProps) {
  // Determine if we are running locally
  const team = useDirectoryTeam();
  const [loadBilling, setLoadBilling] = useState(false);

  const { data, loading } = useApi<BillingLinkEndpoint>(
    '/billing/link',
    {},
    loadBilling,
  );

  const isPro = useIsPro();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card className="max-w-[600px]">
      <CardContent>
        <h2 className="text-lg font-semibold">Account status</h2>
        <p className="mb-2 mt-2">
          Your team is on the <b>{isPro ? 'Pro' : 'Free'} plan</b>
        </p>

        {!isReadOnly && (!team.stripe_customer_id || !isPro) && (
          <div className="mb-3 flex">
            <Button size="sm" className="mr-5" onClick={() => setIsOpen(true)}>
              Find the right plan
            </Button>
          </div>
        )}
        {!isReadOnly && !!team.stripe_customer_id && !data && (
          <Button
            variant="link"
            onClick={() => {
              setLoadBilling(true);
            }}
            disabled={loading}
          >
            {loading ? 'Generating link...' : 'Open billing'}
          </Button>
        )}

        {!isReadOnly && data && (
          <Button variant="link" asChild>
            <a target="_blank" href={data.url} rel="noreferrer">
              Stripe Billing Portal
              <LuExternalLink className="ml-2 h-5 w-5" />
            </a>
          </Button>
        )}
      </CardContent>

      <SettingsUpgradeModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </Card>
  );
}
